import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(public)/mining/page.jsx");
